import { config } from '../config/global'

export const getDirectionOrDefault = (langId, defaultDir) => {
  if (config.languagesLtr.includes(langId)) return 'ltr'
  return defaultDir
}
